<div mat-dialog-title class="dialog-header">
    <span
        class="x-circle"
        hamIconShapes
        icon="assets/hamIcons/x-circle.svg"
        [variant]="'transparent'"
        [size]="'lg'"
        (click)="onClose()"
    ></span>
</div>

<div class="dialog-content">
    <!-- #createForm -->
    <ng-container *ngIf="options">
        <mat-checkbox
            color="primary"
            class="of-that-item-checkbox"
            *ngIf="showOfThatItemCheckBox"
            (change)="onOfThatItemCheckBoxValueChanged($event)"
        >
            <span class="aum-typo-paragraph">
                {{'aumico_templates_group_account_mapping_add_more_items_of_that_item_checkbox' | i18next}}
            </span>
        </mat-checkbox>
        <aumico-form [options]="options" [delegate]="formDelegate" [data]="newState"> </aumico-form>
    </ng-container>
</div>
